module.exports = __webpack_public_path__ + "bafbd9cc14990165a4680d1aa933ad40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/demand/banner-right-01.png
// module id = ./assets/images/demand/banner-right-01.png
// module chunks = 0